import { render, staticRenderFns } from "./EmpresasEnvioAutomatico.vue?vue&type=template&id=1897c57d&"
import script from "./EmpresasEnvioAutomatico.vue?vue&type=script&lang=js&"
export * from "./EmpresasEnvioAutomatico.vue?vue&type=script&lang=js&"
import style0 from "./EmpresasEnvioAutomatico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports